module.exports = __webpack_public_path__ + "img/head.ba8b68dc.png";